<script setup>
// import MiniCalendarView from "@/pages/admin/components/MiniCalendarView.vue";
import { useRouter } from "vue-router";

const props = defineProps({
    location: { type: Object, required: true },
    therapistId: { type: [ String, Number ], required: true },
    dropCache: { type: Boolean, default: false }
});

const router = useRouter();

const weekDays = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ];

function navigateToCalendar(mode = null, modeEventsOnly = false) {
    router.push({
        name: "therapist-calendar",
        params: { therapistId: props.therapistId, locationId: props.location?.ROWID, autoclose: false },
        query: {
            mode: mode,
            modeEventsOnly: modeEventsOnly,
            location_id: props.location?.ROWID,
        }
    });
}
</script>

<template>
  <div class="bg-white shadow">
    <div class="space-x-2 select-none px-4 mt-2 flex">
      <a
        v-if="location.zoho_crm_id != null"
        :href="`https://crm.zoho.com/crm/org805341821/tab/CustomModule17/${location.zoho_crm_id}`"
        target="_blank"
        class="px-4 py-2 bg-blue-500 text-nowrap text-white rounded hover:bg-blue-600"
      >
        Open in CRM
      </a>
      <button
        v-else
        disabled
        class="px-4 py-2 cursor-not-allowed bg-gray-300 text-nowrap text-white rounded"
      >
        Open in CRM
      </button>
      <div class="w-px bg-gray-400 self-stretch"></div>
      <button
        @click="navigateToCalendar('absent')"
        class="w-full py-1.5 bg-red-500 text-white rounded hover:bg-red-600"
      >
        Add Absent
      </button>
      <button
        @click="navigateToCalendar('hart_hours', true)"
        class="w-full py-1.5 bg-green-500 text-white rounded hover:bg-green-600"
      >
        Add Hart Hour
      </button>
      <button
        @click="navigateToCalendar()"
        class="w-full py-1.5 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        View Calendar
      </button>
    </div>
    <div class="p-4">
      <div class="mb-2 text-sm text-gray-600">
        <span v-if="location.address"> · {{ location.address }}</span>
        <a
          v-if="location.latitude && location.longitude"
          :href="`https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`"
          target="_blank"
          class="ml-2 text-blue-500 hover:underline"
          title="View on Google Maps"
        >🗺️ Map</a>
      </div>
      <div class="grid grid-cols-7 gap-2">
        <div v-for="day in weekDays" :key="day" class="text-center text-sm font-medium p-2 bg-gray-50 rounded">
          {{ day }}
        </div>
        <div v-for="(schedule, index) in location.days" :key="index" class="text-center p-2 border rounded">
          <template v-if="schedule">
            <div class="text-sm text-gray-600">{{ schedule.start }}</div>
            <div class="text-xs text-gray-400">to</div>
            <div class="text-sm text-gray-600">{{ schedule.end }}</div>
          </template>
          <template v-else>
            <div class="text-sm text-gray-400">Not Working</div>
          </template>
        </div>
      </div>
    </div>
    <!-- <MiniCalendarView
      :therapist-id="therapistId"
      :location-id="location.ROWID"
      :drop-cache="dropCache"
    /> -->
  </div>
</template>
